import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { apiHandler } from '../../api/apihandler';
import { handleImageUpload } from "../../api/uploads";
import { ADD_MADE_IT_COMMENT } from "../../api/constants";
import Swal from 'sweetalert2'
import EmojiPicker from 'emoji-picker-react';
import LoaderModal from '../loaderModal'

import cross from '../../assets/images/icon/cross.png'


const MadeItCommentBox = ({ madeItId, commentId, setRefreshCommentList, setShowCommentBox, onCommentAdded }) => {
    const navigate = useNavigate();
    const [showLoader, setShowLoader] = useState(false);
    const [postComment, setPostComment] = useState('');
    const [showPicker, setShowPicker] = useState(false);
    const [commentImage, setCommentImage] = useState('');
    const [commentImageFile, setCommentImageFile] = useState('');

    const handleCommentImageChange = (event) => {
        if (localStorage.getItem("nemontoAuthToken")) {
            const file = event.target.files[0];
            if (file) {
                const reader = new FileReader();
                reader.onloadend = async () => {
                    setCommentImageFile(file)
                    setCommentImage(reader.result)
                };
                reader.readAsDataURL(file);
            }
        } else {
            navigate('/')
        }
    };

    async function handleCommentPost() {
        if (localStorage.getItem("nemontoAuthToken")) {
            setShowLoader(true)
            if (commentImageFile) {
                const url = await handleImageUpload(commentImageFile, `feedImages/`, "image/jpeg")
                getCommentPost(madeItId, commentId, url, "0")
            } else {
                getCommentPost(madeItId, commentId, "", "")
            }
        } else {
            navigate('/')
        }
    };

    async function getCommentPost(madeItId, commentId, imagePath, mediaType) {
        try {
            const res = await apiHandler(ADD_MADE_IT_COMMENT, "POST", {
                comment: postComment,
                made_it_id: madeItId,
                comment_id: commentId,
                image_path: imagePath,
                media_type: mediaType,
            })
            if (res.data?.response?.status === 200) {
                if (commentId) {
                    setShowCommentBox(false)
                }
                setRefreshCommentList((prev) => prev + 1)
                if (onCommentAdded) onCommentAdded()
            } else {
                Swal.fire({
                    title: 'Error',
                    text: res?.response?.data?.data?.message,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            }
        } catch (error) {
            console.error(error);
        }
        finally {
            setPostComment("")
            setShowPicker(false)
            setCommentImageFile("")
            setCommentImage("")
            setShowLoader(false)
        }
    }

    return (
        <>
            <LoaderModal showLoader={showLoader} />
            {
                commentImage ?
                    <div>
                        <hr />
                        <div className="col-md-2 col-sm-12 col-lg-2" style={{ marginTop: "10px" }}>
                            <img style={{ height: 70, width: 70, marginRight: "17px", }} loading="lazy" src={commentImage}
                                alt="gallary" className="img-fluid" />
                            <Link style={{ position: "absolute", marginTop: commentId ? "-80px" : "-9px", marginLeft: commentId ? "43px" : "-30px", }}
                                onClick={() => {
                                    setCommentImage("")
                                    setCommentImageFile("")
                                }}>
                                <img style={{ height: 25, width: 25 }} src={cross} alt="remove" />
                            </Link>
                        </div>
                    </div>
                    : null
            }
            <form className="comment-text d-flex align-items-center mt-3">
                <input className="form-control rounded" placeholder="Enter Your Comment"
                    value={postComment} onChange={(e) => setPostComment(e.target.value)} />
                <div className="comment-attagement d-flex" style={{ alignItems: "center" }}>
                    <Link to="#" className="material-symbols-outlined me-3"
                        onClick={() => setShowPicker((val) => !val)}>sentiment_satisfied</Link>
                    <span style={{ marginTop: "7px" }}>
                        <label style={{ cursor: "pointer" }} htmlFor={`madeItCommentImageUpload-${madeItId}-${commentId || 'root'}`} className="material-symbols-outlined me-3">photo_camera</label>
                        <input className="file-upload"
                            id={`madeItCommentImageUpload-${madeItId}-${commentId || 'root'}`} type="file" accept="image/*"
                            onChange={handleCommentImageChange} />
                    </span>
                    <button type="button" className="btn btn-primary" style={{ height: "34px" }} onClick={() => handleCommentPost()}>
                        <span className="material-symbols-outlined">send</span>
                    </button>
                </div>
            </form>
            {showPicker ?
                <EmojiPicker pickerStyle={{ width: "100%" }} onEmojiClick={(emojiObject) => setPostComment((prevMsg) => prevMsg + emojiObject.emoji)} /> : null
            }
        </>
    )
}

export default MadeItCommentBox
